import { __read } from "tslib";
import { playbackTitleCase } from '@dazn/peng-html5-tools-utils';
import { getFeatureIdFromMessageParams } from './getFeatureNameFromMessageParams';
var renderHumanReadableFeatureName = function (packageNamespace, featureNumber, messages) {
    var featureName = getFeatureIdFromMessageParams(packageNamespace, featureNumber, messages);
    var constantCaseFeatureName;
    if (featureName === '_')
        constantCaseFeatureName = 'CORE';
    else {
        var _a = __read(featureName.split('_')), parts = _a.slice(2);
        constantCaseFeatureName = parts.join('_');
    }
    var humanReadableFeatureName = playbackTitleCase(constantCaseFeatureName);
    return humanReadableFeatureName;
};
export { renderHumanReadableFeatureName };
//# sourceMappingURL=renderHumanReadableFeatureName.js.map